import { format } from 'date-fns';
import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography, Chip, Grid, Divider, Box,
} from '@mui/material';

const ViewRequisitionModal = ({ open, onClose, requisition }) => {
    if (!requisition) return null;

    const statusColor = (status) => {
        switch (status) {
            case 'approved': return 'success';
            case 'rejected': return 'error';
            case 'job_created': return 'primary';
            default: return 'warning';
        }
    };

    return (
        <Dialog open={open} onClose={(e, reason) => { if (reason !== 'backdropClick') onClose(e, reason); }} maxWidth="sm" fullWidth>
            <DialogTitle>Requisition Details — {requisition.requisition_id}</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={1.5}>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Role Title</Typography>
                        <Typography variant="body2" fontWeight={600}>{requisition.role_title}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Client</Typography>
                        <Typography variant="body2">{requisition.client_name || '—'}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Department</Typography>
                        <Typography variant="body2">{requisition.department}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">No. of People</Typography>
                        <Typography variant="body2">{requisition.no_of_people}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Hiring Manager</Typography>
                        <Typography variant="body2">{requisition.hiring_manager_name || '—'}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Salary Range</Typography>
                        <Typography variant="body2">
                            {requisition.comp_band_min || 0} – {requisition.comp_band_max || 0}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Priority</Typography>
                        <Box sx={{ mt: 0.5 }}>
                            <Chip
                                label={requisition.priority}
                                color={requisition.priority === 'High' ? 'error' : 'default'}
                                size="small"
                                variant="outlined"
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Status</Typography>
                        <Box sx={{ mt: 0.5 }}>
                            <Chip
                                label={(requisition.status || '').replace(/_/g, ' ')}
                                color={statusColor(requisition.status)}
                                size="small"
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Created By</Typography>
                        <Typography variant="body2">
                            {requisition.creator_first_name ? `${requisition.creator_first_name} ${requisition.creator_last_name} (${requisition.creator_email})` : requisition.creator_email || '—'}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Created Date</Typography>
                        <Typography variant="body2">
                            {requisition.created_at ? format(new Date(requisition.created_at), "dd-MM-yyyy") : '—'}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Approved By</Typography>
                        <Typography variant="body2">
                            {requisition.approver_first_name ? `${requisition.approver_first_name} ${requisition.approver_last_name} (${requisition.approver_email})` : requisition.approver_email || '—'}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Updated Date</Typography>
                        <Typography variant="body2">
                            {requisition.updated_at ? format(new Date(requisition.updated_at), "dd-MM-yyyy") : '—'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}><Divider /></Grid>
                    <Grid item xs={12}>
                        <Typography variant="caption" color="text.secondary">Justification / Notes</Typography>
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mt: 0.5 }}>
                            {requisition.notes || '—'}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewRequisitionModal;

